import $ from 'jquery';
import { debounce, debounce_leading } from '../abstracts/debounce.mjs';

export class SearchInput {
    constructor($mainEl) {
        this.$mainEl = $mainEl;
        this.$form = $mainEl.closest('form');
        this.$inputEl = $mainEl.hasClass('js-search__input') ? $mainEl : $mainEl.find('.js-search__input');
        this.$resetBtn = this.$inputEl && this.$inputEl.length ? this.$inputEl.next('.input-group-prepend').find('.js-search__reset') : null;

        if (this.$mainEl.length && this.$inputEl.length) {
            initForm.call(this);
            initResetBtn.call(this);
        }
    }
}

function initForm() {
    this.$inputEl.on('input', debounce(() => {
        toggleResetBtn.call(this, this.$inputEl.val());
    }, 150));

    this.$inputEl.on('blur', () => {
        removeExtraWhiteSpace.call(this, this.$inputEl);
    });

    this.$inputEl.on('focus', (event) => {
        removeExtraWhiteSpace.call(this, this.$inputEl);
        toggleResetBtn.call(this, this.$inputEl.val());
        this.$mainEl.trigger('hhw.search.focus', this.$inputEl.val());
    });

    this.$form.on('submit', () => {
        removeExtraWhiteSpace.call(this, this.$inputEl);
        this.$mainEl.trigger('hhw.search.submit', this.$inputEl.val());
    });
}

function initResetBtn() {
    const $btn = this.$resetBtn;
    if ($btn.length) {
        $btn.off();
        $btn.on('click', debounce_leading((event) => {
            this.$inputEl.val('');
            this.$inputEl.focus();
            toggleResetBtn.call(this, this.$inputEl.val(), this.$inputEl.val());
            this.$mainEl.trigger('hhw.search.reset', this.$inputEl.val());
        }, 150));
        if (!this.$inputEl.val() || this.$inputEl.val() === '') {
            $btn.fadeOut();
        }
    }
}

function toggleResetBtn(inputVal = null) {
    const $btn = this.$resetBtn;
    if ($btn.length) {
        if (inputVal && inputVal !== '') {
            $btn.fadeIn();
            this.$mainEl.trigger('hhw.search.reset.show', inputVal);
        } else {
            $btn.fadeOut();
            this.$mainEl.trigger('hhw.search.reset.hide', inputVal);
        }
    }
}

function removeExtraWhiteSpace(input) {
    const inputVal = input.val();
    input.val(inputVal.replace(/\s+/g, ' ').trim());
}
